import { ChevronLeftIcon } from "lucide-react"
import { useNavigate, useSearchParams } from "react-router"

import { getLastRoute } from "@/auth/lastRoute"
import { AuthShell } from "@/components/auth/AuthShell"

export function PermissionDenied() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  const handleGoBack = () => {
    const returnTo = searchParams.get("returnTo")
    const lastGoodRoute = getLastRoute()

    // Check if the returnTo route is the same as the last good route
    // If so, it means the user directly navigated to a protected route
    if (returnTo === lastGoodRoute) {
      // Go to home instead of the protected route
      navigate("/")
    } else {
      // Use the last good route
      navigate(lastGoodRoute)
    }
  }

  return (
    <AuthShell
      title="Permission Denied"
      description="You do not have permission to access this resource. Please contact Information Technology to request access."
      primaryLabel="Go Back"
      onPrimaryClick={handleGoBack}
      primaryIcon={<ChevronLeftIcon className="w-4 h-4" />}
    />
  )
}
